import React, { useState, useEffect, useRef, useContext } from 'react';
import { Container, Col, Row, Form } from 'react-bootstrap';
import { AuthContext } from '../../auth/AuthContext';
import { TablaGrupos, TablaPromotorias } from '../../Components/Components';
import '../../pages/Dashboard/dashboard.css';
import { TableCancelaciones, TablePendientes, TableRenovaciones } from './Components';


export const Administracion = ({ initState, updateState }) => {

  const ref = useRef(null);
  const { openMenu, data, loadingData } = initState;
  const [viewTab, setViewTab] = useState(0);
  const [isSticky, setSticky] = useState(false);

  const handleScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled > 0 ? setSticky(true) : setSticky(false)
  };

  return (
    <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
      <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">

        <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{ borderBottom: '1px solid #ccc' }}>
          <Row>
            <Col className="mb-2" xs={12} md={3}>
              <h1 className="ws_title_header">Administración</h1>
            </Col>
          </Row>
        </Container>

        <Container fluid className="mt-5">
          <Row>
            <TablePendientes />
          </Row>
          <Row>
            <TableRenovaciones />
          </Row>
          <Row>
            <TableCancelaciones />
          </Row>
        </Container>
      </div>
    </div>
  )

}